define('persistence/repositories/forwardingNumberRepository',['externalDependencies/kazooApi',
    'common/promises/promiseFactory'], function() {

    return function() {
        var self = this;

        var KazooConstructor = require('externalDependencies/kazooApi');
        var _kazooApi = new KazooConstructor();

        var PromiseFactoryConstructor = require('common/promises/promiseFactory');
        var _promiseFactory = new PromiseFactoryConstructor();

        self.remove = function(forwardingNumberId) {
            if (forwardingNumberId === null) {
                var err = new Error("Missing ForwardingNumber Id");
                throw err;
            }
            else {
                return _promiseFactory.defer(function(deferredObject) {
                    _kazooApi.callAccount('/lobby_forwarding_numbers/'+forwardingNumberId,'DELETE')
                        .done(function(result) {
                            deferredObject.resolve(result.data.data);
                        })
                        .fail(function(error) {
                            error.forwardingNumberId = forwardingNumberId;
                            deferredObject.reject(error);
                        });
                });
            }
        };
    };
});

